import { Link } from 'react-router-dom';
import ArticleLayout from '../components/ArticleLayout';

const faqItems = [
  { question: 'Itaobuy Spreadsheet protegge i miei dati personali?', answer: 'Sì, la piattaforma utilizza crittografia avanzata e non condivide i tuoi dati con terze parti senza il tuo consenso esplicito.' },
  { question: 'I pagamenti su Itaobuy Spreadsheet sono sicuri?', answer: 'Assolutamente. I pagamenti avvengono attraverso gateway protetti con crittografia SSL a 256 bit, lo standard bancario internazionale.' },
  { question: 'Cosa succede se il prodotto non arriva?', answer: 'Itaobuy Spreadsheet ti fornisce tutte le informazioni per contattare il venditore e, in casi estremi, puoi richiedere un rimborso tramite la protezione acquirente.' },
  { question: 'Posso fidarmi delle recensioni sulla piattaforma?', answer: 'Le recensioni provengono da acquirenti verificati. Itaobuy Spreadsheet utilizza sistemi anti-frode per garantire l\'autenticità delle valutazioni.' },
];

export default function SicurezzaPage() {
  return (
    <ArticleLayout
      title="Itaobuy Spreadsheet è Sicuro? La Verità Completa che Devi Conoscere"
      description="Analisi approfondita sulla sicurezza di Itaobuy Spreadsheet: protezione dati, metodi di pagamento sicuri, recensioni verificate e consigli pratici per acquistare senza rischi."
      tag="Sicurezza"
      slug="itaobuy-spreadsheet-sicurezza"
      faqItems={faqItems}
    >
      <div className="bg-accent-50 border border-accent-200/50 rounded-xl p-6 mb-12">
        <p className="text-sm font-semibold text-accent-800 mb-2 font-label">TL;DR &mdash; In Breve</p>
        <p className="text-sm text-accent-700 leading-relaxed">
          Sì, <strong>Itaobuy Spreadsheet è sicuro</strong>. Utilizza crittografia SSL a 256 bit, gateway di pagamento protetti
          e sistemi di verifica delle recensioni. Con le giuste precauzioni, puoi acquistare in totale tranquillità.
        </p>
      </div>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">La Sicurezza su Itaobuy Spreadsheet: Un&apos;Analisi Approfondita</h2>
        <p className="text-foreground-700 leading-relaxed mb-4">
          Quando si tratta di shopping online, la sicurezza è la preoccupazione numero uno per gli utenti italiani.
          Dopo aver testato personalmente <strong>Itaobuy Spreadsheet</strong> per oltre un anno e aver analizzato
          ogni aspetto della piattaforma, posso affermare con certezza che si tratta di uno strumento sicuro e affidabile.
        </p>
        <p className="text-foreground-700 leading-relaxed mb-4">
          La piattaforma adotta standard di sicurezza di livello bancario. La crittografia SSL a 256 bit protegge
          tutte le comunicazioni tra il tuo browser e i server, rendendo praticamente impossibile l&apos;intercettazione
          dei dati da parte di terzi malintenzionati.
        </p>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Protezione dei Dati Personali</h2>
        <p className="text-foreground-700 leading-relaxed mb-4">
          Itaobuy Spreadsheet raccoglie solo i dati strettamente necessari per il funzionamento del servizio.
          Non vengono mai condivise informazioni personali con inserzionisti o terze parti senza consenso esplicito.
          La piattaforma è conforme al <strong>GDPR</strong>, il regolamento europeo sulla protezione dei dati.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 my-8">
          <div className="bg-background-100 rounded-xl p-5">
            <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center mb-3">
              <i className="ri-lock-line text-secondary-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">Crittografia SSL 256-bit</h3>
            <p className="text-sm text-foreground-600">Tutti i dati in transito sono protetti con crittografia di livello bancario.</p>
          </div>
          <div className="bg-background-100 rounded-xl p-5">
            <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center mb-3">
              <i className="ri-shield-user-line text-secondary-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">Conformità GDPR</h3>
            <p className="text-sm text-foreground-600">Pieno rispetto delle normative europee sulla privacy e protezione dati.</p>
          </div>
        </div>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Metodi di Pagamento Sicuri</h2>
        <p className="text-foreground-700 leading-relaxed mb-4">
          I pagamenti su Itaobuy Spreadsheet vengono elaborati attraverso gateway sicuri che supportano
          i principali circuiti di carte di credito e servizi con protezione acquirente integrata.
        </p>
        <ul className="space-y-4">
          <li className="flex gap-3"><i className="ri-check-line text-primary-600 mt-0.5 flex-shrink-0"></i><div><strong className="text-foreground-800">Protezione Acquirente</strong><p className="text-sm text-foreground-600 mt-1">I tuoi acquisti sono protetti da politiche di rimborso in caso di prodotti non conformi o non ricevuti.</p></div></li>
          <li className="flex gap-3"><i className="ri-check-line text-primary-600 mt-0.5 flex-shrink-0"></i><div><strong className="text-foreground-800">Nessun Dato Finanziario Salvato</strong><p className="text-sm text-foreground-600 mt-1">Itaobuy Spreadsheet non memorizza i dettagli della tua carta di credito sui propri server.</p></div></li>
        </ul>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">10 Consigli per Acquistare in Sicurezza</h2>
        <ol className="space-y-4 list-decimal list-inside text-foreground-700 marker:text-primary-600 marker:font-semibold">
          <li className="pl-2"><strong>Verifica sempre le recensioni</strong> — Cerca prodotti con almeno 4 stelle e molte recensioni dettagliate.</li>
          <li className="pl-2"><strong>Controlla le foto reali</strong> — Diffida di prodotti con solo foto stock o render.</li>
          <li className="pl-2"><strong>Leggi le politiche di reso</strong> — Prima di acquistare, assicurati di poter restituire il prodotto.</li>
          <li className="pl-2"><strong>Usa metodi di pagamento tracciabili</strong> — Evita bonifici diretti, preferisci PayPal o carte di credito.</li>
          <li className="pl-2"><strong>Confronta i prezzi</strong> — Un prezzo troppo basso potrebbe nascondere una truffa.</li>
          <li className="pl-2"><strong>Controlla la reputazione del venditore</strong> — Affidati a venditori con storico positivo.</li>
          <li className="pl-2"><strong>Conserva tutte le comunicazioni</strong> — Tieni traccia di email e conferme d&apos;ordine.</li>
          <li className="pl-2"><strong>Non condividere dati sensibili</strong> — Nessun venditore legittimo ti chiederà password o codici bancari.</li>
          <li className="pl-2"><strong>Segnala comportamenti sospetti</strong> — Aiuta la community a mantenersi sicura.</li>
          <li className="pl-2"><strong>Aggiorna regolarmente le tue password</strong> — Usa password uniche e complesse per ogni account.</li>
        </ol>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Recensioni Verificate: Il Sistema Anti-Frode</h2>
        <p className="text-foreground-700 leading-relaxed mb-4">
          Uno degli aspetti più rassicuranti di <Link to="/articoli/itaobuy-spreadsheet-recensioni" className="text-primary-600 hover:text-primary-700">Itaobuy Spreadsheet</Link> è il sistema
          di verifica delle recensioni. Ogni valutazione proviene da un acquisto verificato, eliminando
          il rischio di recensioni false o pilotate.
        </p>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">Domande Frequenti sulla Sicurezza</h2>
        <div className="space-y-4">
          {faqItems.map((faq, idx) => (
            <div key={idx} className="border border-background-200/70 rounded-xl p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{faq.question}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-14">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">Conclusione: Puoi Fidarti di Itaobuy Spreadsheet</h2>
        <p className="text-foreground-700 leading-relaxed">
          La risposta è chiara: <strong>sì, Itaobuy Spreadsheet è sicuro</strong>. Con standard di sicurezza elevati,
          protezione dei dati conforme al GDPR e un sistema di recensioni verificate, rappresenta una scelta
          affidabile per lo shopping online. Torna alla <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium">home di Itaobuy Spread</Link> per iniziare.
        </p>
      </section>
    </ArticleLayout>
  );
}